import { bfsUserWebHttp } from '@/utils/http/index';

/**
 * @description 各业务系统每日消费费用、调用次数 统计表
 * @api https://yapi.ops.yunlizhi.cn/project/10/interface/api/40983
 * @returns
 */
export function fetchPageInfo(data, params) {
  return bfsUserWebHttp.request({
    url: '/bfs-user/control/task/statistic',
    method: 'post',
    data: {
      ...data,
    },
    params,
  });
}

/**
 * @description 以日期+公司纬度查询统计信息，分页查询
 * @api https://yapi.ops.yunlizhi.cn/project/10/interface/api/42702
 * @returns
 */
export function fetchTableList(data, params) {
  return bfsUserWebHttp.request({
    url: '/bfs-user/control/task/statistic/page',
    method: 'post',
    data: {
      ...data,
    },
    params,
  });
}

/**
 * @description 明细分页列表
 * @api https://yapi.ops.yunlizhi.cn/project/10/interface/api/40980
 * @returns
 */
export function fetchDetailTableList(data, params) {
  return bfsUserWebHttp.request({
    url: '/bfs-user/control/task/page',
    method: 'post',
    data: {
      ...data,
    },
    params,
  });
}

/**
 * @description 实时在线人数及分页
 * @api https://yapi.ops.yunlizhi.cn/project/18/interface/api/42723
 * @returns
 */
export function fetchOnlineDetailAndTable(data, params) {
  return bfsUserWebHttp.request({
    url: '/bfs-sso/login_statistic/control/real_time',
    method: 'post',
    data: {
      ...data,
    },
    params,
  });
}

/**
 * @description 未登录人员明细分页
 * @api https://yapi.ops.yunlizhi.cn/project/18/interface/api/42720
 * @returns
 */
export function fetchUnLoginTable(data, params) {
  return bfsUserWebHttp.request({
    url: '/bfs-sso/login_statistic/control/not_login/page',
    method: 'post',
    data: {
      ...data,
    },
    params,
  });
}

/**
 * @description 历史未登录人员明细分页
 * @api https://yapi.ops.yunlizhi.cn/project/18/interface/api/43549
 * @returns
 */
export function fetchHistoryUnLoginTable(data, params) {
  return bfsUserWebHttp.request({
    url: '/bfs-sso/operate/non_login/history/page',
    method: 'post',
    data: {
      ...data,
    },
    params,
  });
}

/**
 * @description 创建导出任务
 * @api https://yapi.ops.yunlizhi.cn/project/547/interface/api/18553
 * @returns
 */
export function upsertOutImport(data, params) {
  return bfsUserWebHttp.request({
    url: '/bfs-exporter/task/create_export',
    method: 'post',
    data: {
      ...data,
    },
    params,
  });
}
